export enum ReasonCodeEnum {
  N_A = 0,
  ApprovedOrAccepted = 1000,
  AuthCompleted = 1001,
  Forced = 1002,
  AuthOnlyDeclined = 1003,
  ValidationFailureSystemRunTrx = 1004,
  ProcessorResponseInvalid = 1005,
  Voided = 1200,
  PartialApproval = 1201,
  ApprovedOptionalFieldsMissing = 1240,
  AccountDeactivatedForFraud = 1301,
  ReservedForFutureFraudReasonCodes = 1302,
  GenericDecline = 1500,
  Call = 1510,
  TransactionNotPermittedTerminal = 1518,
  PickupCard = 1520,
  RetryTrx = 1530,
  CommunicationError = 1531,
  SetupIssueContactSupport = 1540,
  DeviceNotSignatureCapable = 1541,
  DataCouldNotBeDeTokenized = 1588,
  OtherReason = 1599,
  GenericDecline_1601 = 1601,
  Call_1602 = 1602,
  NoReply = 1603,
  PickupCardNoFraud = 1604,
  PickupCardFraud = 1605,
  PickupCardLost = 1606,
  PickupCardStolen = 1607,
  AccountError = 1608,
  AlreadyReversed = 1609,
  BadPIN = 1610,
  CashbackExceeded = 1611,
  CashbackNotAvailable = 1612,
  CIDError = 1613,
  DateError = 1614,
  DoNotHonor = 1615,
  NSF = 1616,
  ExceededWithdrawalLimit = 1617,
  InvalidServiceCode = 1618,
  ExceededActivityLimit = 1619,
  Violation = 1620,
  EncryptionError = 1621,
  CardExpired = 1622,
  Renter = 1623,
  SecurityViolation = 1624,
  CardNotPermitted = 1625,
  TransactionNotPermitted = 1626,
  SystemError = 1627,
  BadMerchantID = 1628,
  DuplicateBatchAlreadyClosed = 1629,
  BatchRejected = 1630,
  AccountClosed = 1631,
  PINTriesExceeded = 1632,
  RequiredFieldsMissingACH = 1640,
  PreviouslyDeclinedTransaction = 1641,
  ContactSupport_1650 = 1650,
  MaxSendingThrottleLimitHitACH = 1651,
  MaxAttemptsExceeded = 1652,
  ContactSupport_1653 = 1653,
  VoidedOnlineReversalFailed = 1654,
  DeclineAVSAutoReversal = 1655,
  DeclineCVVAutoReversal = 1656,
  DeclinePartialAuthAutoReversal = 1657,
  ExpiredAuthorization = 1658,
  DeclinedPartialApprovalNotSupported = 1659,
  BankAccountErrorPleaseDeleteAndReAddToken = 1660,
  DeclinedAuthIncrement = 1661,
  AutoReversalProcessorCantSettle = 1662,
  ManagerNeeded = 1663,
  TokenNotFoundSharingGroupUnavailable = 1664,
  ContactNotFoundSharingGroupUnavailable = 1665,
  AmountError = 1666,
  ActionNotAllowedInCurrentState = 1667,
  OriginalAuthorizationNotValid = 1668,
  ChipReject = 1701,
  IncorrectCVV = 1800,
  DuplicateTransaction = 1801,
  MID_TIDNotRegistered = 1802,
  StopRecurring = 1803,
  NoTransactionsInBatch = 1804,
  BatchDoesNotExist = 1805,
}
